import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "Clipping.svg",
  "use": "Clipping.svg-usage",
  "viewBox": "0 0 64 64",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 64 64\" id=\"Clipping.svg\"><path d=\"M15.0208,52.0207a3,3,0,0,1-3-3v-34a3,3,0,0,1,3-3h34a3,3,0,0,1,3,3v18a3,3,0,0,1-3,3h-10a3,3,0,0,0-3,3v10a3,3,0,0,1-3,3Zm24-14H49.6066a1,1,0,0,1,.707,1.7071L39.7279,50.3137a1,1,0,0,1-1.7071-.7071V39.0208A1,1,0,0,1,39.0208,38.0208Z\" fill-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol